<template>
  <div class="card no-body">
    <div class="card-header d-flex">
        <h3 class="h3 mb-0">Workspace Projects</h3>
      <div class="ml-auto p-1">
        <b-input-group size="sm">
          <b-form-input
            v-model="searchValue"
            type="search"
            placeholder="Search"
          ></b-form-input>
        </b-input-group>
      </div>
    </div>
    <div>
        <div v-if="projects">
            <b-list-group flush class="account-user-list-group">
                <workspace-projects-list-item v-for="project in filterProject()" :project="project" :key="project.projectId"></workspace-projects-list-item>
            </b-list-group>
        </div>
        <div v-else class="text-center p-3">
            <div> No projects are associated with this workspace. </div>
        </div>
    </div>
    <div class="card-footer d-flex">
      <b-button size="sm" variant="outline-primary" class="ml-auto" v-b-modal.project-creation-modal>Create</b-button>
      <project-creation-modal></project-creation-modal>
    </div>
  </div>
</template>
<script>
import WorkspaceProjectsListItem from '#/ui/Components/Workspace/WorkspaceProjectsListItem.vue';
import ProjectCreationModal from '#/ui/Components/ProjectCreationModal.vue';

export default {
  components: {
    ProjectCreationModal,
    WorkspaceProjectsListItem,
  },
  data() {
    return {
      searchValue: '',
    };
  },
  computed: {
    projects() {
      return this.$store.getters.projects;
    },
  },
  methods: {
    filterProject() {
      return Object.values(this.$store.getters.projects).filter((project) => project.name.toLowerCase().match(new RegExp(this.searchValue.trim().toLowerCase(), 'g')));
    },
  },
};
</script>
<style>
</style>
